import React from 'react';
import * as S from '@/components/Ad/FloatingButtons/FloatingButtons.styles';
import { ChatButton } from '@/components/Ad/FloatingButtons/ChatButton';
import { CallButton } from '@/components/Ad/FloatingButtons/CallButton';

export const FloatingButtons = () => {
  return (
    <S.Box>
      <CallButton />
      <ChatButton />
    </S.Box>
  );
};
